function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: auto;\n\n  ::-webkit-scrollbar {\n    width: ", ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n\n  ::-webkit-scrollbar-track {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
var colorsList = process.env.NODE_ENV !== "production" ? Object.keys(colors) : {};

var px2rem = function px2rem(px) {
  return px / 16 + "rem";
};

var margin = function margin(obj) {
  return px2rem(obj.marginTop || 0) + " " + px2rem(obj.marginRight || 0) + " \n  " + px2rem(obj.marginBottom || 0) + " " + px2rem(obj.marginLeft || 0);
};

var padding = function padding(obj) {
  return px2rem(obj.paddingTop || 0) + " " + px2rem(obj.paddingRight || 0) + " \n  " + px2rem(obj.paddingBottom || 0) + " " + px2rem(obj.paddingLeft || 0);
};

var createSvgIcon = function createSvgIcon(iconObj) {
  var Icon = function Icon(props) {
    var size = props.size,
        color = props.color,
        rest = _objectWithoutPropertiesLoose(props, ["size", "color"]);

    return React.createElement("svg", _extends({
      width: size,
      height: size,
      viewBox: "0 0 " + iconObj.width + " " + iconObj.height
    }, rest), iconObj.paths.map(function (p, key) {
      return React.createElement("path", {
        key: key,
        d: p,
        fill: colors[color]
      });
    }));
  };

  Icon.displayName = iconObj.name;
  Icon.propTypes = process.env.NODE_ENV !== "production" ? {
    size: PropTypes.number,
    color: PropTypes.oneOf(colorsList)
  } : {};
  Icon.defaultProps = {
    size: 32,
    color: 'black'
  };
  return Icon;
};

var setInputValue = function setInputValue(inputElement, value) {
  var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  setValue.call(inputElement, value);
  var event;

  if (typeof Event === 'function') {
    event = new Event('input', {
      bubbles: true
    });
  } else {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('input', true, false);
  }

  inputElement.dispatchEvent(event);
};

var ScrollableContainer = styled('div')(_templateObject(), px2rem(10), colors.grey4, colors.white);
export { px2rem, margin, padding, createSvgIcon, setInputValue, ScrollableContainer };